import is from 'typescript-styled-is'
import styled from '../../../theme'

const ButtonsWrapper = styled.div<IButtonsWrapperProps>`
  display: flex;
  justify-content: center;
  margin: ${({ size }) => (size ? 15 * size : 15)}px
    ${({ size }) => (size ? 20 * size : 20)}px;
  ${is('isDesktop')`
  margin: 0px
  position: absolute;
  top: ${({ size }) => (size ? 0.5 * size : 0.5)}em;
  right: ${({ size }) => (size ? 1.5 * size : 1.5)}em;
  `}
`

export default ButtonsWrapper

export interface IButtonsWrapperProps {
  isDesktop?: boolean
  size?: number
}
